import { render, staticRenderFns } from "./ulicPicker.vue?vue&type=template&id=b855c974&"
import script from "./ulicPicker.vue?vue&type=script&lang=js&"
export * from "./ulicPicker.vue?vue&type=script&lang=js&"
import style0 from "./ulicPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports